var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
    _vm.$style.draggable,
    _vm.isDragging && _vm.$style.dragging,
    _vm.isFadeOutShown && _vm.$style.afterFade
  ],on:{"mousedown":_vm.mouseDownHandler,"click":_vm.clickHandler,"scroll":_vm.scrollHandler}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }